export default __webpack_public_path__ + "static/media/expensesaitop1.d63113e6.png";